import { Button, ButtonType, ParagraphTitle, theme } from 'modules/ui';
import { NavigationAndActionDelete } from 'modules/ui/icons';
import { bytesToSize } from 'modules/utils/validationHelpers';
import { FileContainer, UploadedFilesContainer } from '../styled';

export interface UploadedFilesListProps {
  files?: File[];
  removeFile: (fileName: string) => void;
}

export const UploadedFilesList: React.FC<UploadedFilesListProps> = ({
  files,
  removeFile,
}) => (
  <UploadedFilesContainer>
    {files?.map((file) => (
      <FileContainer key={file.name}>
        <ParagraphTitle>
          {file?.name} ({bytesToSize(file?.size)})
        </ParagraphTitle>
        <Button
          type={ButtonType.Icon}
          color={theme.colors.primaryK10}
          hoverColor={theme.colors.primaryK7}
          icon={<NavigationAndActionDelete />}
          onClick={() => removeFile(file.name)}
        />
      </FileContainer>
    ))}
  </UploadedFilesContainer>
);
